import React from 'react'
import type { CMSQuickLinkImageCard } from '@/types/sanity'
import { Link } from '@/components/Link/Link'
import { ResponsiveImage } from '@/components/Shared/ResponsiveImage'

import styles from './ImageCard.module.scss'

type QuickLinkImageCard = {
  card: CMSQuickLinkImageCard
}

export const ImageCard: React.FC<QuickLinkImageCard> = ({ card }) => {
  const { image, destinationUrl, subText } = card

  return (
    <div className={styles.container}>
      {destinationUrl?.url ? (
        <Link link={destinationUrl}>
          <ResponsiveImage
            document={image}
            overrides={{
              mobileAspectRatio: '1/1',
              desktopAspectRatio: '1/1',
              customSizes: [640, 768, 1024, 1200],
            }}
          />
          {subText && (
            <p className={`${styles.subtext} type-label`}>{subText}</p>
          )}
        </Link>
      ) : (
        <>
          <ResponsiveImage
            document={image}
            overrides={{
              mobileAspectRatio: '1/1',
              customSizes: [640, 768, 1024, 1200],
            }}
          />
          {subText && <p>{subText}</p>}
        </>
      )}
    </div>
  )
}
